/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { filterByModel } from '../../utils/helper';
import EquipmentUtils from '../../utils/EquipmentUtils';

class EquipmentSelect extends React.Component {

	constructor(props, context) {
		super(props, context);
		this.handleEquipmentChanged = this
			.handleEquipmentChanged
			.bind(this);
		this.handleModeChanged = this
			.handleModeChanged
			.bind(this);
	}

	handleEquipmentChanged(e) {
		const { orderId, workOrderActions, outlet, techInventory } = this.props;
		const selectedItem = techInventory ? techInventory.find(item => item && item.get('serialNumber') === e.target.value) : null;

		let selectedPortType = null;
		if (selectedItem) {
			selectedPortType = selectedItem.get('portTyoe');
		}

		if (EquipmentUtils.isGponFiberModemType(outlet)) {
			workOrderActions.outletUpdate({
				orderId: orderId,
				newModel: selectedItem ? selectedItem.get('itemPart') : 'none',
				outletId: outlet.get('equipmentOutlet'),
			});
		}

		workOrderActions.outletUpdate({
			orderId: orderId,
			newSerialNumber: e.target.value,
			outletId: outlet.get('equipmentOutlet'),
			selectedPortType: selectedPortType
		});
	}

	handleModeChanged(e) {
		const { orderId, workOrderActions, outlet } = this.props;
		workOrderActions.outletUpdate({
			orderId: orderId,
			newMode: e.target.value,
			outletId: outlet.get('equipmentOutlet')
		});
	}

	getAllowedEquipment(outlet) {
		const { techInventory, houseEquipmentDetails, customerDetails } = this.props;

		const requiredPortType = outlet.get('requiredPortType');
		const disableAddPlusSwap = outlet.get('disableAddsAndSwaps');
		const allowedEquipmentModels = outlet.get('allowedEquipmentModels');
		const notAllowedEquipmentModels = outlet.get('notAllowedEquipmentModels');
		const isCustomerOwnedModel = EquipmentUtils.isCustomerOwnedModem(outlet);
		const signalAccessCode = customerDetails.get("signalAccessCode");
		let displayInventory = [];

		let inventory = techInventory;
		if (EquipmentUtils.isGreenfieldAccount(signalAccessCode) && (EquipmentUtils.isFiberTerminal(outlet) || EquipmentUtils.isVOIPOutlet(outlet))) {
			if (houseEquipmentDetails.size > 0) {
				inventory = houseEquipmentDetails
			}
		}

		if (inventory) {
			displayInventory = inventory.filter(item => item && item.get('status') && item.get('status').trim().toLowerCase() !== 'returned to technician');
		}

		let equipmentOptions = [];

		if (displayInventory && !disableAddPlusSwap) {

			equipmentOptions = displayInventory.filter((item) => {
				const foundItem = item
					.get('portTypes')
					.find((portType) => {
						const matchingPortType = requiredPortType.find((portTypeItem) => {
							const itemModel = item.get('itemPart');
							if (portType === null || portTypeItem === null) {
								return (portType === portTypeItem);
							} else {
								if (allowedEquipmentModels.size > 0 && (EquipmentUtils.isToSearchByAllowedModels(outlet) || filterByModel.includes(portTypeItem))) {
									//This is an exception to treat allowed equipment models diferently, when they come. We should streamline this and put on a config / DB
									return allowedEquipmentModels.includes(itemModel) && portType.trim() === portTypeItem.trim();
								}
								else {
									if (notAllowedEquipmentModels) {
										return !notAllowedEquipmentModels.includes(itemModel) && portType.trim() === portTypeItem.trim();
									}
									return (portType.trim() === portTypeItem.trim());
								}
							}
						});

						return matchingPortType;
					});

				if (isCustomerOwnedModel) {
					return false;
				}

				if (foundItem) {
					return true;
				}

				return false;
			}).sort((a, b) => {
				return allowedEquipmentModels.indexOf(a.get('itemPart').trim()) - allowedEquipmentModels.indexOf(b.get('itemPart').trim())
			}).map((item, index) => {
				return (
					<option
						style={{
							fontSize: '10px'
						}}
						key={`tech_equip_${index}`}
						value={item.get('serialNumber') || ''}
						disabled={false}>
						{item.get('serialNumber')}&nbsp; ({item.get('description')})</option>
				);
			});
		}

		return equipmentOptions;
	}

	render() {
		const { outlet, customerDetails } = this.props;

		const disableAddPlusSwap = outlet.get('disableAddsAndSwaps');
		const currentNone = !outlet.get('seriaNumber') && !outlet.get('originalSerialNumber');

		let removeOption = null,
			currentOption = null,
			actionOption = null;

		if ((outlet.get('seriaNumber') && (!outlet.get('action')) || disableAddPlusSwap)) {
			removeOption = (
				<option
					value=""
					style={{
						fontSize: '10px'
					}}>
					Remove: {outlet.get('seriaNumber')}</option>
			);

			currentOption = (
				<option
					value={outlet.get('seriaNumber') || ''}
					style={{
						fontSize: '10px'
					}}
					disabled={disableAddPlusSwap}
				>
					Current: {outlet.get('seriaNumber')}</option>
			);
		}

		if (outlet.get('originalSerialNumber')) {

			currentOption = (
				<option
					value={outlet.get('originalSerialNumber') || ''}
					style={{
						fontSize: '10px'
					}}>
					Current: {outlet.get('originalSerialNumber')}</option>
			);
		}

		if (currentNone) {

			currentOption = (
				<option
					value=""
					style={{
						fontSize: '10px'
					}}>
					Current: None</option>
			);
		}

		if (outlet.get('action') === 'add' || outlet.get('action') === 'update') {

			actionOption = (
				<option
					value={outlet.get('seriaNumber') || ''}
					style={{
						fontSize: '10px'
					}}>
					{outlet.get('action')}: {outlet.get('seriaNumber')}</option>
			);
		}

		if (outlet.get('action') === 'remove') {

			actionOption = (
				<option
					value=""
					style={{
						fontSize: '10px'
					}}>
					Remove: {outlet.get('originalSerialNumber')}</option>
			);

			removeOption = null;

		}

		if (outlet.get('isTransferMove') && outlet.get('emtaGatewayTransferFlag')) {
			currentOption = null;
		}

		const components = [<select
			key="equipment-select"
			disabled={false}
			className="browser-default"
			value={outlet.get('seriaNumber') || ''}
			onChange={this.handleEquipmentChanged}>
			{currentOption}
			{actionOption}
			{removeOption}
			{this.getAllowedEquipment(outlet)}
		</select>,
		<br key="equipment-select-br" />,
		EquipmentUtils.isFiberTerminal(outlet) &&
		customerDetails.get('signalAccessCode') === 'F' &&
		<div key="mode-select">
			<b>Mode</b>
			<select
				disabled={false}
				className="browser-default"
				value={outlet.get('mode') || 'none'}
				onChange={this.handleModeChanged}>
				<option>Bridge (BR)</option>
				<option>Gateway (GW)</option>
			</select>
		</div>]

		return (<div>{components}</div>);
	}
}

EquipmentSelect.propTypes = {
	outlet: PropTypes.object,
	orderId: PropTypes.string,
	techInventory: PropTypes.object,
	workOrderActions: PropTypes.object,
	disabled: PropTypes.bool,
	isSkinnyInstallType: PropTypes.bool
};
export default EquipmentSelect;



// WEBPACK FOOTER //
// ./src/components/equipment/EquipmentSelect.js